import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AwanSatu, FollowWhalesIll } from "../components";
import { PreloadedWallet } from "../context/preloadedWalletContext";
import { ThemeContext } from "../context/themeContext";
import { WalletContext } from "../context/walletContext";
import {
  AppList,
  Mintbot,
  NormalInspector,
  ReverceInspector,
  RoadMap,
  TierSystem, Topid,
  TrueHolder
} from "../page";
import "./App.scss";
import BalanceHistory from "./BalanceHistory";
import Bot from "./Bot";
import Dashboard from "./Dashboard";
import LogoPack from "./Documentation/LogoPack";
import MileStone from "./Documentation/MileStone";
import TokeNomic from "./Documentation/TokenNomic";
import FastTrax from "./FastTrax";
import MultipleWalet from "./MultipleWallet";
import Thankyou from "./Thankyou";
import Whale from "./Whale";

function App() {
  const [theme, setTheme] = useState("light");
  const [isWalletConnect, setIsWalletConnect] = useState(false);
  const [preloadedWallet, setPreloadedWallet] = useState([])

  return (
    <Router>
      <AwanSatu />
      <ThemeContext.Provider value={{ theme, setTheme }}>
        <div className={`app ${theme}`}>
          <Switch>
            <Route path="/" exact>
              <Dashboard theme="dark" />
            </Route>
            <Route path="/token_inspector" exact>
              <NormalInspector theme="dark" />
            </Route>
            <Route path="/reverse_inspector" exact>
              <ReverceInspector theme="dark" />
            </Route>
            <Route path="/fasttrax">
              <WalletContext.Provider
                value={{ isWalletConnect, setIsWalletConnect }}
              >
                <FastTrax />
              </WalletContext.Provider>
            </Route>
            <Route path="/multiwallet">
              <PreloadedWallet.Provider
                value={{ preloadedWallet,setPreloadedWallet }}
              >
                <MultipleWalet />
              </PreloadedWallet.Provider>
            </Route>
            <Route path="/whale">
              <Whale />
            </Route>
            <Route path="/mintbot">
              <Mintbot />
            </Route>
            <Route path="/topid">
              <Topid />
            </Route>
            <Route path="/trueholder">
              <TrueHolder />
            </Route>
            <Route path="/balance_history">
              <BalanceHistory />
            </Route>
            <Route path="/roadmap">
              <RoadMap />
            </Route>
            <Route path="/tier">
              <TierSystem />
            </Route>
            <Route path="/applist">
              <AppList />
            </Route>

            {/* NEW DOC */}
            <Route path="/logopack">
              <LogoPack />
            </Route>
            <Route path="/tokenomic">
              <TokeNomic />
            </Route>
            <Route path="/milestone">
              <MileStone />
            </Route>
            <Route path="/interest">
              <Thankyou />
            </Route>
            <Route path="/bot">
              <Bot />
            </Route>
          </Switch>
        </div>
      </ThemeContext.Provider>
    </Router>
  );
}
export default App;
